export enum PaymentProfileEvent {
  CREATED = 'TL_PAYMENT_PROFILE_CREATED_EVENT',
  CREATE_FAILED = 'TL_PAYMENT_PROFILE_CREATE_FAILED_EVENT',
  UPDATED = 'TL_PAYMENT_PROFILE_UPDATED_EVENT',
  UPDATE_FAILED = 'TL_PAYMENT_PROFILE_UPDATE_FAILED_EVENT',
}

export enum PaymentProfileStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  SINGLE_USE = 'SINGLE_USE',
  THIRD_PARTY = 'THIRD_PARTY',
}

export const PaymentProfileStatusDefault = PaymentProfileStatus.ACTIVE
